import { AppContext } from '@farris/devkit';
import { Subject } from 'rxjs';
import { OnDestroy } from '@angular/core';

abstract class AbstractEndEdit implements OnDestroy {
  private messagePipe: Subject<any>;
  constructor(protected appContext: AppContext) {
    this.messagePipe = this.appContext && this.appContext.messagePipe;
    if (this.messagePipe) {
      this.messagePipe.subscribe((message: any) => {
        if (message && message.type === 'endEdit') {
          this.endEdit(message);
        }
      });
    }
  }
  ngOnDestroy(): void {
    // if (this.messagePipe) {
    //   this.messagePipe.unsubscribe();
    // }
  }
  public abstract endEdit(message: any);
}
export { AbstractEndEdit };
